export enum QuestionsPermission {
  FullAccessManager = 'full_access_manager',
  ViewOnlyManager = 'view_only_manager',
  Submitter = 'submitter',
  None = 'none',
}
